var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.sector
    ? _c("span", { staticClass: "sector" }, [_vm._v(_vm._s(_vm.sector))])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }